import graphql from "babel-plugin-relay/macro";

export const VIEWER_QUERY_TYPE_FRAGMENT = graphql`
	fragment userNotifications_ViewerQueryTypeFragment on ViewerQueryType {
		...microLearningReward_ViewerQueryTypeFragment
	}
`;
